import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: '256-bit SSL Encryption',
      description: 'Bank-level security'
    },
    {
      icon: 'Lock',
      label: 'Data Protection',
      description: 'GDPR compliant'
    },
    {
      icon: 'CheckCircle',
      label: 'Verified Platform',
      description: 'Trusted by thousands'
    }
  ];

  return (
    <div className="mt-40 md:mt-48 lg:mt-56">
      <div className="text-center mb-24">
        <p className="text-sm md:text-base text-muted-foreground font-caption">
          Your financial data is protected with enterprise-grade security
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-20 lg:gap-24">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-16 bg-muted/30 rounded-lg transition-smooth hover:bg-muted/50"
          >
            <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-success/10 rounded-lg mb-12">
              <Icon name={feature?.icon} size={24} color="var(--color-success)" strokeWidth={2} />
            </div>
            <h3 className="text-sm md:text-base font-caption font-medium text-foreground mb-4">
              {feature?.label}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground font-caption">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityBadges;